import noop from "lodash-es/noop";
import {
  createContext,
  Dispatch,
  SetStateAction,
  useMemo,
  useState,
} from "react";

export const GrayScaleContext = createContext<{
  isGrayScale: boolean;
  setIsGrayScale: Dispatch<SetStateAction<boolean>>;
}>({
  isGrayScale: false,
  setIsGrayScale: noop,
});

export const GrayScaleProvider = ({ children }: React.PropsWithChildren) => {
  const [isGrayScale, setIsGrayScale] = useState(false);
  const value = useMemo(() => ({ isGrayScale, setIsGrayScale }), [isGrayScale]);

  return (
    <GrayScaleContext.Provider value={value}>
      {children}
    </GrayScaleContext.Provider>
  );
};
